import React from 'react';
import { useDealByIdQuery } from 'api';
import { useParams } from 'react-router-dom';
import { PERMISSIONS } from 'constants/permissions';
import { CommunicationHub, HasAccess } from 'components';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';

export const DealCommunicationHub: React.FC = () => {
  const { hasAccess } = useAccessControl();
  const { id } = useParams() as { id: string };
  const { data: { isFinalStatus } = {} } = useDealByIdQuery({ id }, { skip: !id });
  return (
    <HasAccess role={PERMISSIONS.notes.note.read}>
      <CommunicationHub
        entity={'DEAL'}
        hasAccessToWrite={hasAccess(PERMISSIONS.notes.note.write)}
        hasAccessToOtherNoteWrite={hasAccess(PERMISSIONS.notes.other_note.write)}
        hasAccessToOtherNoteDelete={hasAccess(PERMISSIONS.notes.other_note.delete)}
        isFinalStatus={isFinalStatus}
        isTabsVisible={true}
      />
    </HasAccess>
  );
};
